/**
 * Created by Administrator on 2018/2/23.
 */

class UrlManager {
  constructor(baseUrl) {
    this.http = baseUrl;
  }

  getProjectsByAccount_U() {
    return this.http + '/projects/list';
  }

  getSuperOrganizationsByAccount_U(aid) {
    return this.http + '/organization/selectAllSuperOrganizationExceptOwn/' + aid;
  }

  getProvinces_U(rank) {
    return this.http + '/city/selectByRank/' + rank;
  }

  getCityOrCountry_U(parent) {
    return this.http + '/city/selectByParentCoding/' + parent;
  }

  /**
   * 根据项目id 起始时间 获取周期号（当前测量周期）
   */
  getPeriodNoByProjectAndTime_U(projectId, startTime, endTime) {
    return this.http + '/measureData/getPeriodNoByProjectIdAndTime?projectId=' + projectId + '&startTime=' + startTime + '&endTime=' + endTime;
  }

  /**
   * 根据项目id 起始时间（后台将起始时间减一周） 获取周期号（上一测量周期）
   */
  getLastPeriodNoByProjectAndTime_U(projectId, startTime, endTime) {
    return this.http + '/measureData/getLastPeriodNoByProjectIdAndTime?projectId=' + projectId + '&startTime=' + startTime + '&endTime=' + endTime;
  }

  getItemsByProject_U(pid) {
    return this.http + '/monitorItem/selectByProjectId/' + pid;
  }

  uploadDataByHand_U(pid) {
    return this.http + '/monitorItem/uploadDataByHand?projectId=' + pid;
  }

  /**
   * 获取点组的参数信息
   * @param projectId
   * @return
   */
  getPointGroupConfigParam_U(projectId){
    return this.http +'/monitorPointGroup/getConfigParam?projectId=' + projectId;
  }

  getMonitorTypes_U() {
    return this.http + '/monitorType/selectAll';
  }

  getRelPointsOfItem_U(iid) {
    return this.http + '/monitorPoint/monitorItem/' + iid + '/relMonitorPoint';
  }

  /**
   * 查询指定监测项下指定可见范围类型的测点
   * @param iid
   * @param visibleType
   * @returns {string}
   */
  getRelPointsOfItemAndVisibleType(iid,visibleType) {
    return this.http + '/monitorPoint/monitorItem/' + iid + '/visibleType/'+visibleType;
  }

  getMonitorPointAndRelList_U(projectId) {
    return this.http + '/monitorPoint/' + projectId + '/pointAndRelList';
  }

  /*测点点组*/
  getMonitorPointGroupByProId_U(proId) {
    return this.http + '/point_group/list?proj_id=' + proId;
  }

  /*已关联测点*/
  getRelMonitorPointGroup_point_U(groupId) {
    return this.http + '/monitorPoint/pointGroup/' + groupId + '/relPoint';
  }

  /*未关联测点*/
  getNotRelMonitorPointGroup_point_U(projectId, groupId) {
    return this.http + '/monitorPoint/pointGroup/notRelPoint?projectId=' + projectId + '&groupId=' + groupId;
  }


  getSensorInfoByItem_U(itemId) {
    return this.http + '/sensors/getSensorInfoByItem?monitorItemId=' + itemId;
  }

  getMcusByProject_U(projectId) {
    return this.http + '/projects/' + projectId + '/mcus/list';
  }

  getSensorAndRelInfoByProject_U(proId) {
    return this.http + '/projects/' + proId + '/sensorAndRelList';
  }

  getSensorExtraInfoById_U(id) {
    return this.http + '/sensors/getSensorExtraInfoById?id=' + id;
  }

  /**
   * 获取与监测项关联的点组
   */
  getRelGroupsByItem_U(iid) {
    return this.http + '/monitorPointGroup/monitorItem/' + iid + '/relPointGroup'
  }

  getUnRelPointsByItem_U(iid) {
    return this.http + '/monitorPoint/monitorItem/' + iid + '/notRelMonitorPoint';
  }
  /**
   * 测点点组与监测项的关联
   */
  getRelItemPointGroupByItem_U(itemId) {
    return this.http + '/monitorPointGroup/monitorItem/' + itemId + '/relPointGroup';
  }

  getNotRelItemPointGroupByItem_U(itemId) {
    return this.http + '/monitorPointGroup/monitorItem/' + itemId + '/notRelPointGroup';
  }

  getCheckRecordByProject_U(pid) {
    return this.http + '/checkRecords/selectByProjectId/' + pid;
  }

  getHistoryData_U() {
    return this.http + "/historyData/query";
  }

  /**
   * 全站仪设置
   */
  getCtrlPoint_ProjectIMC_U(projectId, IMCId) {
    return this.http + '/projects/' + projectId + '/IMCs/' + IMCId + '/controlPoints';
  }

  getTsTask_ProjectIMC_U(projectId, IMCId) {
    return this.http + '/projects/' + projectId + '/IMCs/' + IMCId + '/tsTasks';
  }

  getStation_Task_U(tsTaskId) {
    return this.http + '/tsTasks/' + tsTaskId + '/observationStations';
  }

  getSection_ProjectIMC_U(projectId, IMCId) {
    return this.http + '/projects/' + projectId + '/IMCs/' + IMCId + '/sections';
  }

  getSurvey_Station_U(stationId) {
    return this.http + '/observationStations/' + stationId + '/surveyPoints';
  }

  getPointGroup_Station_U(oid) {
    return this.http + '/observationStations/' + oid + '/pointGroups';
  }

  getSurvey_PointGroup_U(gId) {
    return this.http + '/pointGroups/' + gId + '/surveyPoints';
  }

  getSurveyNoGroup_Station_U(oid) {
    return this.http + '/observationStations/' + oid + '/noPointGroup/surveyPoints';
  }

  getPeriodPage_UN(projectId) {
    return this.http + '/period/getPeriodListByProjectId/' + projectId;
  }

  getPeriodTimeSlice_U(periodId) {
    return this.http + '/period/' + periodId + '/timeSliceString';
  }

  getAlarmDevice_U(projectId){
    return this.http + '/alarmDevice/selectAllByProId/' + projectId;
  }

  /**
   * GNSS设备与组
   *
   */
  getGPSDevicePage_U(imcId, projectId) {
    return this.http + '/GpsDevice/list/' + imcId + '/listByIMCAndPro?projectId=' + projectId;
  }

  getGPSGroupPage_U(imcId, projectId) {
    return this.http + '/GpsGroup/list/' + imcId + '/listByIMCAndPro?projectId=' + projectId;
  }

  getRelGPSDeviceByGroupId_U(groupId) {
    return this.http + '/GpsDevice/GpsGroup/' + groupId + '/relGpsDevice/';
  }

  getUnRelGPSDeviceByGroupId_U(imcId, projectId, groupId) {
    return this.http + '/GpsDevice/GpsGroup/' + imcId + '/notRelGpsDevice?projectId=' + projectId + '&groupId=' + groupId;
  }

  getMonitorPointNotGpsDevicePage_U( projectId, imcId) {
    return this.http + '/monitorPoint/monitorPointNotGpsDeviceList?projectId=' + projectId + '&imcId=' + imcId;
  }

  /***
   * 机构文件列表
   */
  getOrganizationFiles_U(organizationId) {
    return this.http + '/fileInfo/organization/technicalDoc?organizationId=' + organizationId;
  }

  /***
   * 上传报表模板列表
   */
  getProjectReportTemplate_U(projectId) {
    return this.http + '/reportForms/getProjectReportTemplate/' + projectId;
  }

  downloadFiles_U(id) {
    return this.http + '/fileInfo/downloadFile?id=' + id;
  }

  getCheckRecordPicture_U(id) {
    return this.http + '/checkRecords/picture/' + id;
  }

  /**
   * 获取预警信息
   */

  getAlarmMessageByProject_U(projectId) {
    return this.http + '/alarmMessage/getPageByProjectIdAndTime?projectId=' + projectId;
  }

  /*
   * 获取指定类型的所有消息（分页查询）*/
  getMessageLogListByCategory_U(category) {
    return this.http + '/messageLog/getMessageLogListByCategory?category=' + category;
  }

  /**
   * 通过项目Id获取指定项目的项目图
   */
  getProjectMap_U(projectId) {
    return this.http + '/projectMap/getMapByProjectId/' + projectId;
  }

  /***
   * 下载报表(整个项目)
   */
  downloadReportOfProject_U() {
    return this.http + '/reportForms/createReport';
  }

  /***
   * 下载报表(单个监测项)
   */
  downloadReportOfItem_U() {
    return this.http + '/reportData/export/excel';
  }

  /**
   * IMS平差数据下载
   * @param projectId
   * @param observationName
   * @param startTime
   * @param endTime
   * @return
   */
  getRMSEData_U(projectId,observationName,startTime,endTime){
    return this.http + '/measureData/getRMSEData?projectId='+ projectId + '&observationName='+ observationName+'&startTime='+ startTime+'&endTime='+ endTime;
  }

  /**
   * 获取observationName
   * @param projectId
   * @return
   */
  getObservationName_U(projectId) {
    return this.http + '/observationStations/getByProjectId/'+ projectId ;
  }
}
class WsUrlManager {
  constructor(wsRoot) {
    this.wsRoot = wsRoot;
  }
}

const Factory = {
  getUrlManager (http) {
    return new UrlManager(http);
  },
  getWsUrlManager(wsRoot){
    return new WsUrlManager(wsRoot)
  }
};
export default Factory;



// WEBPACK FOOTER //
// ./src/apis/urls.js